import type { BoxProps } from '../box/box';

export const variantConfig = {
  default: {
    border: 'neutral300',
    background: 'neutral150',
  },
  success: {
    border: 'success500',
    background: 'success200',
  },
  action: {
    border: 'primary400',
    background: 'primary200',
  },
  alert: {
    border: 'alert500',
    background: 'alert200',
  },
  warning: {
    border: 'warning500',
    background: 'warning200',
  },
  info: {
    border: 'info500',
    background: 'info200',
  },
  noValue: {
    border: 'neutral200',
    background: 'neutral000',
  },
} as const satisfies Record<string, BoxProps>;
